import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_4 = { class: "card-body p-10" }
const _hoisted_5 = { class: "settings-tabs ps-0 mb-0 list-unstyled" }
const _hoisted_6 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing settings-card" }
const _hoisted_7 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-md-6" }
const _hoisted_10 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_11 = { class: "input-group" }
const _hoisted_12 = { class: "col-md-6" }
const _hoisted_13 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_14 = { class: "input-group" }
const _hoisted_15 = { class: "col-md-6" }
const _hoisted_16 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_17 = { class: "input-group" }
const _hoisted_18 = { class: "col-md-6" }
const _hoisted_19 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_20 = { class: "input-group" }
const _hoisted_21 = { class: "col-md-6" }
const _hoisted_22 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_23 = { class: "input-group" }
const _hoisted_24 = { class: "col-md-6" }
const _hoisted_25 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_26 = { class: "input-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("ul", _hoisted_5, [
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                to: "/account-settings",
                class: "fs-md-15 fs-lg-16 fw-medium text-decoration-none d-block w-100 rounded-1 text-center transition"
              }, {
                default: _withCtx(() => _cache[7] || (_cache[7] = [
                  _createTextVNode(" Account Settings ", -1)
                ])),
                _: 1,
                __: [7]
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                to: "/settings-statuts",
                class: "fs-md-15 fs-lg-16 fw-medium text-decoration-none d-block w-100 rounded-1 text-center transition"
              }, {
                default: _withCtx(() => _cache[8] || (_cache[8] = [
                  _createTextVNode("Status ", -1)
                ])),
                _: 1,
                __: [8]
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                to: "/settings-type-clients",
                class: "fs-md-15 fs-lg-16 fw-medium text-decoration-none d-block w-100 rounded-1 text-center transition"
              }, {
                default: _withCtx(() => _cache[9] || (_cache[9] = [
                  _createTextVNode("Types des clients ", -1)
                ])),
                _: 1,
                __: [9]
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                to: "/settings-banks",
                class: "fs-md-15 fs-lg-16 fw-medium text-decoration-none d-block w-100 rounded-1 text-center transition"
              }, {
                default: _withCtx(() => _cache[10] || (_cache[10] = [
                  _createTextVNode("Liste des banques ", -1)
                ])),
                _: 1,
                __: [10]
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                to: "/settings-social-links",
                class: "fs-md-15 fs-lg-16 fw-medium text-decoration-none d-block w-100 rounded-1 text-center transition"
              }, {
                default: _withCtx(() => _cache[11] || (_cache[11] = [
                  _createTextVNode("Social Link ", -1)
                ])),
                _: 1,
                __: [11]
              })
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("form", {
            onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
          }, [
            _cache[18] || (_cache[18] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Add Social Media Link", -1)),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _cache[12] || (_cache[12] = _createElementVNode("span", { class: "input-group-text rounded-0 fs-14 fw-bold text-primary" }, [
                      _createElementVNode("i", { class: "ph-bold ph-facebook-logo lh-1 fs-md-18" })
                    ], -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.settingData.facebook) = $event)),
                      class: "form-control shadow-none rounded-0 text-black"
                    }, null, 512), [
                      [_vModelText, _ctx.settingData.facebook]
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _cache[13] || (_cache[13] = _createElementVNode("span", { class: "input-group-text rounded-0 fs-14 fw-bold text-primary" }, [
                      _createElementVNode("i", { class: "ph-fill ph-twitter-logo lh-1 fs-md-18" })
                    ], -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.settingData.twitter) = $event)),
                      class: "form-control shadow-none rounded-0 text-black"
                    }, null, 512), [
                      [_vModelText, _ctx.settingData.twitter]
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _cache[14] || (_cache[14] = _createElementVNode("span", { class: "input-group-text rounded-0 fs-14 fw-bold text-primary" }, [
                      _createElementVNode("i", { class: "ph-bold ph-linkedin-logo lh-1 fs-md-18" })
                    ], -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.settingData.linkedin) = $event)),
                      class: "form-control shadow-none rounded-0 text-black"
                    }, null, 512), [
                      [_vModelText, _ctx.settingData.linkedin]
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _cache[15] || (_cache[15] = _createElementVNode("span", { class: "input-group-text rounded-0 fs-14 fw-bold text-primary" }, [
                      _createElementVNode("i", { class: "ph-bold ph-instagram-logo lh-1 fs-md-18" })
                    ], -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.settingData.instagram) = $event)),
                      class: "form-control shadow-none rounded-0 text-black"
                    }, null, 512), [
                      [_vModelText, _ctx.settingData.instagram]
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _cache[16] || (_cache[16] = _createElementVNode("span", { class: "input-group-text rounded-0 fs-14 fw-bold text-primary" }, [
                      _createElementVNode("i", { class: "ph-bold ph-youtube-logo lh-1 fs-md-18" })
                    ], -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.settingData.youtube) = $event)),
                      class: "form-control shadow-none rounded-0 text-black"
                    }, null, 512), [
                      [_vModelText, _ctx.settingData.youtube]
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _cache[17] || (_cache[17] = _createElementVNode("span", { class: "input-group-text rounded-0 fs-14 fw-bold text-primary" }, [
                      _createElementVNode("i", { class: "ph-bold ph-snapchat-logo lh-1 fs-md-18" })
                    ], -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.settingData.snapchat) = $event)),
                      class: "form-control shadow-none rounded-0 text-black"
                    }, null, 512), [
                      [_vModelText, _ctx.settingData.snapchat]
                    ])
                  ])
                ])
              ])
            ]),
            _cache[19] || (_cache[19] = _createElementVNode("div", { class: "d-sm-flex align-items-center justify-content-between" }, [
              _createElementVNode("button", {
                class: "default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success",
                type: "submit"
              }, " Save Changes ")
            ], -1))
          ], 32)
        ])
      ])
    ])
  ]))
}